module.exports = __webpack_public_path__ + "static/media/catholic.b0bbb9e6.png";